import AccordionContainer from './AccordionContainer'
import AccordionContainerPanel from './AccordionContainerPanel'
import AccordionContainerHeader from './AccordionContainerHeader'
import AccordionContainerHeaderButton from './AccordionContainerHeaderButton'

export default {
  AccordionContainer,
  AccordionContainerPanel,
  AccordionContainerHeader,
  AccordionContainerHeaderButton,
}



// WEBPACK FOOTER //
// ./src/js/components/accordion/index.js